import { Component } from '@angular/core';
import { enableRipple } from '@syncfusion/ej2-base';
import { Menu, MenuItemModel, FieldSettingsModel } from '@syncfusion/ej2-angular-navigations';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DropDownButtonModule, ItemModel } from '@syncfusion/ej2-angular-splitbuttons'
import { Router, Data, RoutesRecognized } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

enableRipple(true);
import $ from 'jquery'; 

@Component({
  selector: 'app-daylily-layout',
  templateUrl: './daylily-layout.component.html',
  styleUrls: ['./daylily-layout.component.css'],
})

export class DaylilyLayoutComponent {
  token = null;
  title = 'Daylily Birth and Breastfeeding';
  buildDate = "11:57 Thursday, February 26, 2026";
  public canonical = "";

  constructor(private router: Router) { }

  public horMenuItems: MenuItemModel[]= [
      { id: "home-component", url: 'home', text: "Home"},
      { id: "about", text: "About", url: 'about'},
      { id: "classes", url: 'classes', text: "Classes"},
      { id: "breastfeeding", url: 'breastfeeding', text: "Breastfeeding Support"},
      { id: "resources", url: 'resources', text: "Resources"}
  ];
  
    public vertMenuItems: ItemModel[]= [
      { id: "home-component", url: 'home', text: "Home"},
      { id: "about", text: "About", url: 'about'},
      { id: "classes", url: 'classes', text: "Classes"},
      { id: "breastfeeding", url: 'breastfeeding', text: "Breastfeeding Support"},
      { id: "resources", url: 'resources', text: "Resources"}
  ];
  
  public navMenuStartValue: string = "About";
  public menuFields: FieldSettingsModel = {
        itemId: 'id',
        text: 'text',
        parentId: 'pId',
        url: 'url'
  };
}
